import axios from 'axios';
import store from '../../store';

export default {
    upload(data) {

        var started_at = new Date();

        let options = {
            url: window.apiUrl + '/drive-upload',
            method: 'POST',
            data: data,
            onUploadProgress: e => {
                var seconds_elapsed = (new Date().getTime() - started_at.getTime()) / 1000;
                var bytes_per_second = seconds_elapsed ? e.loaded / seconds_elapsed : 0;
                var kbytes_per_second = bytes_per_second / 1000;

                let percentCompleted = Math.floor((e.loaded * 100) / e.total);

                if (percentCompleted < 99) {
                    var data = {
                        type: 'uploadProgress',
                        data: {
                            progress: percentCompleted,
                            loaded: e.loaded,
                            total: e.total,
                            speed: kbytes_per_second
                        }
                    };

                }  else {
                    var data = {
                        type: 'uploadProgress',
                        data:null
                    }
                }

                store.dispatch('populate', data);              

            },
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };

        return axios.request(options).then(function(response) {
            return response;
        }).catch(function(e) {
            console.log(e);
        })
    },

}



// WEBPACK FOOTER //
// ./src/services/google/drive.js